import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'

import "./index.css"
import { Fetcher } from '../../../Helpers/fetcher';
import { Notify } from '../../../Helpers/notification';
import { formatDateTime, isExpired } from '../../../Helpers/utils';
import { Card, Dropdown, Spinner } from 'react-bootstrap';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationListStandalone, PaginationProvider, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import BootstrapTable from 'react-bootstrap-table-next';
import { switchUser } from '../../../Helpers/switchUser';

const SubSuperAdminUserList = ({ app }) => {
	const apiPath = app.apiPath;
	const userId = app.userId;
	const history = useHistory();

	const [userList, setUserList] = useState([])
	const [loading, setLoading] = useState(false);

	const getUserList = async () => {
		try {
			setLoading(true)
			const res = await Fetcher.get(`${apiPath}/api/obd/sub/superadmin/user/list/${userId}`)
			const data = Array.isArray(res) ? res : []
			setUserList(data)
		} catch (error) {
			Notify.notify("Error while getting the user list")
			console.log("getUserList", error)
		} finally {
			setLoading(false)
		}
	}

	const switchUserFn = (userId) => {
		Fetcher.post(apiPath + "/api/obd/switch/user", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ userId: userId }),
		})
			.then((res) => {
				switchUser(res.userid, res.token, res.role);
				if (res.role.includes('ROLE_SUSER')) {
					window.location.href = "/sub-user-report";
				} else {
					window.location.href = "/";
				}
				Notify.notify('User Switch Successfully');
			})
			.catch((err) => {
				console.error("Error while switching user", err);
				Notify.notify("Error while switching user");
			});
	};
	useEffect(() => {
		getUserList()
	}, [])

	const columns = [
		{
			dataField: 'userId',
			text: 'User Id',
			sort: true,
			hidden: false
		},
		{
			dataField: 'username',
			text: 'User Name',
			sort: true,
			hidden: false
		},
		{
			dataField: 'company',
			text: 'Company',
			sort: true,
			hidden: false,
		},
		{
			dataField: 'userType',
			text: 'Type',
			sort: true,
			hidden: false,
		},
		{
			dataField: 'parentUser',
			text: 'Parent',
			sort: true,
			hidden: false,
		},
		{
			dataField: 'expiryDate',
			text: 'User Expiry',
			sort: true,
			hidden: false,
		},
		{
			dataField: 'deleted',
			text: 'Status',
			sort: true,
			hidden: false,
			formatter: (cell, row) => {
				return isExpired(row.expiryDate) ? "Validity Expired" : (row.deleted === 0 ? "Active" : "In-Active")
			}
		},
		{
			dataField: 'switchUser',
			text: 'Switch User',
			sort: true,
			hidden: false,
			formatter: (cell, row) => {
				return <img
					src="/assets/switch-user.png"
					alt="Switch User"
					style={{ width: "30px", height: "30px", cursor: "pointer" }}
					onClick={() => switchUserFn(row.userId)}
				/>
			}
		},
		{
			dataField: 'actions',
			text: 'Actions',
			isDummyField: true,
			formatter: (cell, row) => {
				return (
					<Dropdown>
						<Dropdown.Toggle
							size="sm"
							id={`dropdown-${row.mid}`}

						>
							Actions
						</Dropdown.Toggle>

						<Dropdown.Menu style={{ width: "fit-content" }}>
							<Dropdown.Item onClick={() => history.push(`/sub-super-admin/update-user/${row.userId}`)}>
								Edit User
							</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				);
			}
		}
	];

	const { SearchBar, ClearSearchButton } = Search;
	const defaultSorted = [{
		dataField: 'userId',
		order: 'desc'
	}];
	const paginationOption = {
		custom: true,
		totalSize: userList.length,
		sizePerPage: 10,
		sizePerPageList: [10, 25, 50, 100],
	};

	return (
		<Card>
			<Card.Header>Sub Super Admin List</Card.Header>
			<Card.Body>

				<div className="user-list-table-cont">
					{loading ? (
						<div className="text-center">
							<Spinner animation="border" />
						</div>
					) : (
						<PaginationProvider pagination={paginationFactory(paginationOption)}>
							{
								({
									paginationProps,
									paginationTableProps
								}) => (
									<ToolkitProvider
										keyField="userId"
										data={userList}
										columns={columns}
										search
										bootstrap4
									>
										{
											props => (
												<div className="">
													<div className="d-flex justify-content-between align-items-center mb-2">

														<div>
															Show{" "}
															<SizePerPageDropdownStandalone {...paginationProps} />

															<span className="search-cont ms-2">
																<SearchBar {...props.searchProps} />
															</span>

															<ClearSearchButton
																className="btn btn-secondary btn-sm ms-2"
																{...props.searchProps}
															/>
														</div>

														{/* RIGHT SIDE BUTTONS */}
														{/* <div className="d-flex align-items-center gap-2">
															<Link to="/create-module" className="btn btn-primary btn-sm">
																Create New Module
															</Link>
														</div> */}
													</div>

													<hr />
													<div className="module-list-table-wrapper">
														<BootstrapTable
															bordered
															striped
															condensed
															defaultSorted={defaultSorted}
															wrapperClasses="table-responsive module-list-table-responsive"
															classes="userCampaignList-table"
															{...props.baseProps}
															{...paginationTableProps}
															noDataIndication={"No Module to show"}
														/>
													</div>
													<PaginationListStandalone {...paginationProps} />
												</div>
											)
										}
									</ToolkitProvider>
								)
							}
						</PaginationProvider>
					)}
				</div>

			</Card.Body>
		</Card>
	)
}

export default SubSuperAdminUserList